import { apiClient } from './client'
import type { AuditLog, AuditListResponse, AuditStats } from '@/types/audit'

export const auditsApi = {
  /**
   * Get audit logs with filtering and pagination
   */
  async list(params?: {
    userId?: string
    category?: string
    action?: string
    startDate?: string
    endDate?: string
    page?: number
    pageSize?: number
  }) {
    const response = await apiClient.get<{
      success: boolean
      data: AuditListResponse
    }>('/audits', { params })
    return response.data
  },

  /**
   * Get a single audit log entry by ID
   */
  async getById(id: string) {
    const response = await apiClient.get<{
      success: boolean
      data: AuditLog
    }>(`/audits/${id}`)
    return response.data
  },

  /**
   * Get audit statistics and trends
   */
  async getStats(params?: { startDate?: string; endDate?: string }) {
    const response = await apiClient.get<{
      success: boolean
      data: AuditStats
    }>('/audits/stats', { params })
    return response.data
  },
}
